export const generateAuthUrl = (codeChallenge) => {
    const authUrl = new URL(process.env.REACT_APP_IABILET_OAUTH_AUTHORIZATION_URL);
    authUrl.searchParams.append('response_type', 'code');
    authUrl.searchParams.append('client_id', process.env.REACT_APP_IABILET_OAUTH_CLIENT_ID);
    authUrl.searchParams.append('redirect_uri', process.env.REACT_APP_IABILET_OAUTH_REDIRECT_URI);
    authUrl.searchParams.append('scope', 'email profile');
    authUrl.searchParams.append('code_challenge', codeChallenge);
    authUrl.searchParams.append('code_challenge_method', 'S256');
    authUrl.searchParams.append('state', crypto.randomUUID());

    return authUrl.toString();
};

export const generateCodeVerifier = () => {
    const array = new Uint8Array(32);
    window.crypto.getRandomValues(array);
    return btoa(String.fromCharCode(...array))
        .replace(/\+/g, '-')
        .replace(/\//g, '_')
        .replace(/=+$/, '');
};

export const generateCodeChallenge = async (codeVerifier) => {
    const encoder = new TextEncoder();
    const data = encoder.encode(codeVerifier);
    const digest = await window.crypto.subtle.digest('SHA-256', data);

    return btoa(String.fromCharCode(...new Uint8Array(digest)))
        .replace(/\+/g, '-')
        .replace(/\//g, '_')
        .replace(/=+$/, '');
};
